import { render, staticRenderFns } from "./dataTab.vue?vue&type=template&id=c7737322&"
import script from "./dataTab.vue?vue&type=script&lang=js&"
export * from "./dataTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports